import { SortingFn, sortingFns} from '@tanstack/react-table'
export const COLUMNS =(t:any)=> [
  {
    header: 'ID',
    accessorKey: 'transaction_id'
  },
  {
    header: t('profile.transactions.amount'),
    accessorKey: 'amount',
    cell: (a:any) => {
      a = a.cell.getValue()
      const total = a?.donate + a?.bonus
      if (!isFinite(total)) return '—'
      return (total > 0 ? '+':'') + new Intl.NumberFormat('ru-RU').format(Number(total?.toFixed(1))) + ' ₽'
    },
    sortingFn: fuzzySort
  },
  {
    header: t('profile.transactions.balance'),
    accessorKey: 'balance',
    cell: (info:any) => {
      return isFinite(info.getValue()) ? 
        new Intl.NumberFormat('ru-RU').format(Number(info.getValue()?.toFixed(1))) + ' ₽' : '—'
    },
    sortingFn: fuzzySort
  },
  {
    header: t('profile.transactions.transaction'),
    accessorKey: 'transaction',
  },
  {
    header: t('profile.transactions.date'),
    accessorKey: 'date',
    enableSorting: false,
  }
]
export const getDiffClassName = (value:any) => {
  if (value > 0) {
    return `td_positive`;
  } else if (value < 0) {
    return `td_negative`;
  }
}
export const getRolesCellClassName = (column:string, value:any) => {
  if (['amount'].includes(column)) {
    if (value > 0) {
      return `td_positive`;
    } else if (value < 0) {
      return `td_negative`;
    }
  }
  if (['refund'].includes(column)) return 'td_refund'
  return ""
}
const fuzzySort: SortingFn<any> = (rowA, rowB, columnId) => {
  return sortingFns.basic (rowA, rowB, columnId)
}